import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {UploadFileComponent} from '../../ui/upload/uploadfile.component';
import {DatePipe} from '@angular/common';
import {CommandUtil} from '../../../global/commandutil';
import {NhomTinTuc} from '../../../models/danhmuc/nhomtintuc';
import {NewsService} from '../../../service/info/service-news';
import {NewsFileService} from '../../../service/info/service-newsfile';
import {NhomTinTucService} from '../../../service/danhmuc/service-nhomtintuc';
import {NewsFile} from '../../../models/info/newsfile';
import {Sessioncommand} from '../../../global/sessioncommand';

@Component({
  templateUrl: './create.component.html'

})
export class SoanTinBaiComponent implements OnInit, AfterViewInit {

  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public id: number=0;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public submitValidate = false;
  public editor = ClassicEditor;
  public editor2 = ClassicEditor;
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[];
  public dateHieuLuc: Date;
  public dateHetHieuLuc: Date;
  public dataNhomTinTuc: NhomTinTuc[];
  public picture: string;
  constructor(  public newsService: NewsService,
                public formBuilder: FormBuilder,
                public toastr: ToastrService,
                public newsFileService: NewsFileService,
                public nhomTinTucService: NhomTinTucService,
                public commandUtil: CommandUtil,
                public datepipe: DatePipe,
                public commandUitls: CommandUtil

  ) {
  }
  ngAfterViewInit() {
  }
  public onReady( editor ) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
    editor.editing.view.change( writer => {
      writer.setStyle( 'height', '300px', editor.editing.view.document.getRoot() );
      writer.setStyle( 'border', '1px solid', editor.editing.view.document.getRoot() );
    } );
  }
  ngOnInit(): void {

    this.frmGroup = new FormGroup({
      id: new FormControl('0'),
      title: new FormControl(),
      detail: new FormControl(''),
      summary: new FormControl(''),
      author: new FormControl(''),
      picture: new FormControl(''),
      sourceOfInformation: new FormControl(''),
      publicDate: new FormControl(''),
      expiryDate: new FormControl(''),
      documentTypeID: new FormControl(0),
      usersID: new FormControl(Sessioncommand.staffId)

    });
    this.frmGroup = this.formBuilder.group({
      id: ['', Validators.nullValidator],
      title: ['' , Validators.compose([validateEmpty]) ],
      detail: ['', Validators.nullValidator],
      summary: ['', Validators.nullValidator],
      author: ['', Validators.nullValidator],
      sourceOfInformation: ['', Validators.nullValidator],
      publicDate: ['', Validators.nullValidator],
      expiryDate: ['', Validators.nullValidator],
      documentTypeID: ['0', Validators.nullValidator],
      picture: ['0', Validators.nullValidator],
      usersID: ['0', Validators.nullValidator]
    });

    this.nhomTinTucService.getAll().subscribe(data => this.dataNhomTinTuc = data);
    this.uploadUrl= this.newsFileService.urlUpload;
    this.deleteUrl= this.newsFileService.urlDelete;

  }
  get f() { return this.frmGroup.controls; }
  public edit(id: number) {
    this.id= id;
    this.isEdit = true;
    this.newsService.getById(id).pipe(first())
      .subscribe(x => {this.frmGroup.patchValue(x);
        this.dateHieuLuc= this.commandUitls.getDate(this.frmGroup.value.publicDate);
        this.dateHetHieuLuc= this.commandUitls.getDate(this.frmGroup.value.expiryDate);
      });
    let files: NewsFile[];
    this.fileLists =  [];
    this.newsFileService.findAllByNewsId(id).subscribe(
      x => {
        files = x;
        for(let i=0; i< files.length; i++)
        {
          this.fileLists.push({ id: files[i].id,
            title: files[i].name ,
            name: files[i].fileKey,
            size: files[i].size,
            fileType: files[i].width,
            folder: files[i].folder });
        }
        this.uploadFileComponent.uploadCommand["files"]= this.fileLists;


      });


  }
  public createItem ()
  {
    this.frmGroup.value.publicDate = this.datepipe.transform(this.dateHieuLuc, 'dd/MM/yyyy');
    this.frmGroup.value.expiryDate = this.datepipe.transform(this.dateHetHieuLuc, 'dd/MM/yyyy');
    this.frmGroup.value.picture= this.picture;
    this.frmGroup.value.usersID= Sessioncommand.staffId;
    this.newsService.add(this.frmGroup.value).subscribe(
      {
        next: (data) => {
          this.uploadFileComponent.id = data.documentId;
          this.uploadFileComponent.uploadCommand.upload( this.uploadFileComponent.uploadCommand.getFilesData());
          this.toastr.success(language.add_success_record, language.message);

        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      });
  }

  onSubmit()
  {

    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
      this.createItem();
  }

  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      let reader: FileReader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event1) => {
        this.picture = event1.target.result.toString();
      }
    }
  }

}

